import { Page } from "src/app/core/models/page";
import { SortOrder } from 'src/app/core/interface/sort-order';

export class AdvisingAbnormalTableDetailGetRequest extends Page {
  adNo: string;
  sortOrder: SortOrder | null;

  constructor() {
    super();
    this.adNo = '';
    this.sortOrder = null;
  }
}
